import { render, staticRenderFns } from "./SubscriptionDetails.vue?vue&type=template&id=5f1752a8&"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormRadio, BFormRadioGroup, BFormInvalidFeedback, BFormGroup, BInputGroup, BFormInput, BCardBody, BCard, BForm, BContainer, BModal, BButton} from 'bootstrap-vue'
    installComponents(component, {BFormRadio, BFormRadioGroup, BFormInvalidFeedback, BFormGroup, BInputGroup, BFormInput, BCardBody, BCard, BForm, BContainer, BModal, BButton})
    


    import installDirectives from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBModal} from 'bootstrap-vue'
    installDirectives(component, {'b-modal': VBModal})
    

export default component.exports